import type { ProfessionalTypeEnum } from '@gql/graphql';
import { useTranslation } from '@presentation/utils';
import { Modal, ModalCloseButton, SectionTitle } from '..';
import * as Styled from './styled';
import type { JoinProFormModalProps } from './types';

export * from './types';

const TITLE_COLOR_PER_PRO_TYPE: Record<ProfessionalTypeEnum, 'purple' | 'blue'> = {
  VET: 'blue',
  GROOMER: 'purple',
  EDUCATOR: 'purple',
};

export const JoinProFormModal = (props: JoinProFormModalProps) => {
  const { modal, formComponent, type } = props;

  const { translate } = useTranslation();

  return (
    <Modal {...modal}>
      <Styled.StyledCard size="medium" isModal>
        <ModalCloseButton modal={modal} />
        <SectionTitle color={TITLE_COLOR_PER_PRO_TYPE[type]}>
          {translate('joinPro.formTitle')}
        </SectionTitle>
        {formComponent}
      </Styled.StyledCard>
    </Modal>
  );
};
